module.exports = __webpack_public_path__ + "static/img/avatar-s-19.908c8b78.png";